<form #form="ngForm">
  <div class="">
    <div class="row">
      <div class="col-xs-12">
          <h2 translate>Show Appointment List</h2>
      </div>
    </div>
    <div class="">
      <div class="row">
        <div class="input-field col col-xs-12 col-md-4 panel-row-bottom">
          <div class="form-group">
            <label class="active" for="{{Id}}-lName" translate>Last Name</label>
            <input id="{{Id}}-lName"
                    class="form-control"
                    type="text"
                    name="lastname"
                    [(ngModel)]="lastName"
                    [ngModelOptions]="{standalone: true}"
                    class="form-control" />
          </div>
        </div>
        <div class="input-field col col-xs-12 col-md-4 panel-row-bottom">
          <div class="form-group">
            <label class="active" for="{{Id}}-fName" translate>First Name</label>
            <input id="{{Id}}-fName"
                    class="form-control"
                    type="text"
                    name="firstname"
                    [(ngModel)]="firstName"
                    [ngModelOptions]="{standalone: true}"
                    class="form-control">
          </div>
        </div>
        <div class="input-field col col-xs-12 col-md-4 panel-row-bottom">
          <div class="form-group">
            <ap-date-picker
                  [baseId]="Id + '-brithdate'"
                  [required]="false"
                  [form]="form"
                  name="birthdate"
                  [labelName]="'Date of Birth'"
                  [(ngModel)]="birthDate"
                  [defaultToStartOfDay]="true">
            </ap-date-picker>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="input-field col col-xs-12 col-md-6 panel-row-bottom">
          <div class="form-group">
            <label class="active" for="Id + '-service-site'" translate>Service Site</label>
            <ap-findcontrol [baseId]="Id + '-service-site'"
                            [findControlId]="findControlIdService.FacilityServiceSite"
                            [(selectedPk)]="serviceSiteSelected"
                            [placeHolder]=""
                            [singleSelect]="true">
            </ap-findcontrol>
          </div>
        </div>
        <div class="input-field col col-xs-12 col-md-6 panel-row-bottom">
          <div class="form-group">
            <label class="active" for="Id + '-patient-program'" translate>Program</label>
            <ap-findcontrol [baseId]="Id + '-patient-program'"
                            [findControlId]="findControlIdService.FacilityPatientProgram"
                            [(selectedPks)]="patientProgramSelected"
                            [placeHolder]=""
                            [singleSelect]="false">
            </ap-findcontrol>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="input-field col col-xs-12 panel-row-bottom">
          <div class="form-group">
            <label class="active" for="Id + '-timespan'" translate>Timespan</label>
            <ap-timespan-find-control [baseId]="Id + '-timespan'"
                            [findControlId]="findControlIdService.ListTimespan"
                            [(selectedPk)]="timeSpanSelected"
                            [placeHolder]=""
                            [singleSelect]="true"
                            [additionalSearchParameters]="timeframeAdditionalSearchParams"
                            (selectedPkChange)="timespanChanged()"
                            (customDateRangeChange)="dateRangeChanged($event)">
            </ap-timespan-find-control>
          </div>
        </div>
      </div>
      <div class="row search-grid">
        <div class="red pull-right" *ngIf="hasSearched && !hasSearchFilters">
          Please enter search terms
        </div>
        <button id="{{Id}}-search-button"
                class="btn btn-primary apply-defaults-btn pull-right"
                type="button"
                [disabled]="searching"
                (click)="onClickSearch()">
          Search<ap-spinner *ngIf="searching"></ap-spinner>
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <div class="error" *ngIf="searchError">Search Error</div>
        <fp-appointment-results [searchResult]="searchResult"></fp-appointment-results>
      </div>
    </div>
  </div>
</form>
